import template from './flight-segment.html';

const DIRECTIVE_NAME = AtcFlightSegment.DIRECTIVE_NAME = 'ktAtcFlightSegment';
export default function AtcFlightSegment() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: AtcFlightSegmentController,
        controllerAs: '$ctrl',
        scope: {
            segment: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
            searchParameters: `=${DIRECTIVE_NAME}SearchParameters`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function AtcFlightSegmentController(
    atcFlightRecommendationService,
    atcFlightSegmentService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        toggleAlternatives,
        toggleDetails,
        initSelectedGroup,
        isDepartureHighlighted: false,
        isArrivalHighlighted: false,
    });

    function $onInit() {
        initSelectedGroup();
        vm.isAlternativesAvailable = vm.segment.FlightGroups.length > 1;
    }

    function initSelectedGroup() {
        vm.group = atcFlightSegmentService.getSelectedGroup(vm.selectedFlights, vm.segment);
        initHighlightAirports();
        vm.isAlternativesVisible = false;
    }

    function initHighlightAirports() {
        if (!atcFlightRecommendationService.isRoundTrip(vm.recommendation)) {
            return;
        }

        if (atcFlightSegmentService.isOutwardSegment(vm.recommendation, vm.segment)) {
            vm.isDepartureHighlighted = !atcFlightRecommendationService.doesOutwardDepartEqualInwardArrival(vm.selectedFlights, vm.recommendation);
            vm.isArrivalHighlighted = !atcFlightRecommendationService.doesInwardDepartEqualOutwardArrival(vm.selectedFlights, vm.recommendation);
        } else if (atcFlightSegmentService.isReturnSegment(vm.recommendation, vm.segment)) {
            vm.isDepartureHighlighted = !atcFlightRecommendationService.doesInwardDepartEqualOutwardArrival(vm.selectedFlights, vm.recommendation);
            vm.isArrivalHighlighted = !atcFlightRecommendationService.doesOutwardDepartEqualInwardArrival(vm.selectedFlights, vm.recommendation);
        }
    }

    function toggleAlternatives() {
        vm.isAlternativesVisible = !vm.isAlternativesVisible;
        vm.isDetailsVisible = false;
    }

    function toggleDetails() {
        vm.isDetailsVisible = !vm.isDetailsVisible;
        vm.isAlternativesVisible = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-segment-component.js